// routes
// utils
import { private_server } from '../utils/axios';

// ----------------------------------------------------------------------

function jwtDecode(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );

  return JSON.parse(jsonPayload);
}

// ----------------------------------------------------------------------

export const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

  const decoded = jwtDecode(accessToken);

  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

export const isSoon2ExpireToken = (accessToken, offset) => {

  if (!accessToken) {
    return false;
  }

  if(!document.hidden){
    const decoded = jwtDecode(accessToken); // exp is in seconds
    const currentTime = Date.now() / 1000; // seconds
    const diff = decoded.exp - currentTime
    //console.log('Current time',currentTime)
    //console.log('Expiration time',decoded.exp)
    //console.log('Diff time (h)',diff / 60 / 60 )
    if(diff < offset){
      return true
    } 
  }
  return false
};

// ----------------------------------------------------------------------

export const tokenExpired = (exp) => {
  // eslint-disable-next-line prefer-const
  let expiredTimer;

  const currentTime = Date.now();

  // Test token expires after 10s
  // const timeLeft = currentTime + 10000 - currentTime; // ~10s
  const timeLeft = exp * 1000 - currentTime;

  clearTimeout(expiredTimer);

  expiredTimer = setTimeout(() => {
    alert('Token expired');

    localStorage.removeItem('accessToken');

    window.location.href = '/login';
  }, timeLeft);
};

// ----------------------------------------------------------------------

export const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken);

    //private_server.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    private_server.defaults.headers.common.Authorization = `${accessToken}`;

    // This function below will handle when token is expired
    const { exp } = jwtDecode(accessToken); // ~3 days by minimals server
    tokenExpired(exp);
  } else {
    localStorage.removeItem('accessToken');
    delete private_server.defaults.headers.common.Authorization;
  }
};
